import "../src/main/detailview/detailview_component";
import "../src/main/bounce/bounce_component";
import "../src/resources/scss/assetsDetailviewClean.scss";
import { initSlotReadyListener } from "../src/main/detailview/slotReadyHandler";

initSlotReadyListener();
